import { apiClient } from '@/shared/api/client'
import { isValidRole, ROLE_ME_PATH } from '@/shared/constants/roles'

export async function sendOtp(email) {
  const response = await apiClient.post('/auth/send-otp', { email })
  return response.data
}

export async function login({ email, otp }) {
  const response = await apiClient.post('/auth/login', { email, otp })
  return response.data
}

export async function registerFcmToken(fcmToken) {
  console.log('➡️ registerFcmToken CALLED')

  console.log('➡️ FCM token being sent:', fcmToken)

  try {
    console.log('➡️ Sending POST /auth/fcm-token')

    const response = await apiClient.post('/auth/fcm-token', {
      fcmToken,
    })

    console.log('✅ /auth/fcm-token RESPONSE:', response)

    return response.data
  } catch (error) {
    console.error('❌ /auth/fcm-token ERROR:', error)
    throw error
  }
}

export async function logout(fcmToken) {
  const response = await apiClient.post('/auth/logout', {
    fcmToken,
  })

  return response.data
}

export async function fetchProfileByRole(role) {
  if (!isValidRole(role)) {
    throw new Error('Invalid role')
  }

  const response = await apiClient.get(ROLE_ME_PATH[role])
  return response.data
}
